import './App.css';
import AppRoutes from './routes/Routes';
import { Toaster } from 'react-hot-toast';
import Layout from './components/layout/Layout';

function App() {
  return (
    <>
      {/* React Hot Toast Notifications */}
      <Toaster 
        position="top-right"
        reverseOrder={false}
        gutter={8}
        toastOptions={{
          // Default options
          duration: 3000,
          style: {
            background: '#363636',
            color: '#fff',
            padding: '16px',
            borderRadius: '8px',
            fontSize: '14px',
            maxWidth: '500px',
          },
          
          // Success toast style
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          
          // Error toast style
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
      
      {/* Application Routes */}
      <AppRoutes />
    </>
  );
}

export default App;
